import { lazy, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

const PanelPage = lazy(() => import('@/page/PanelPage/PanelPage'));

import { LocoPage } from '@/page/LocoPage';
import { MainPage } from '@/page/MainPage';
import { LocoAdminPage } from '@/page/LocoAdminPage';
import { StationPage } from '@/page/StationPage';
import { NotFoundPage } from '@/page/NotFoundPage';

interface Route {
    path: string;
    element: ReactNode;
}

const enum AppPages {
    MAIN = 'MAIN',
    LOCO = 'LOCO',
    LOCO_ADMIN = 'LOCO_ADMIN',
    CAMERA = 'CAMERA',
    STATION = 'STATION',
    PANEL = 'PANEL',

    NOT_FOUND = 'NOT_FOUND',
}

export const AppRoutes: Record<AppPages, string> = {
    [AppPages.MAIN]: '/',
    [AppPages.LOCO]: '/loco/', // + lodoId
    [AppPages.LOCO_ADMIN]: '/admin',
    [AppPages.CAMERA]: '/camera',
    [AppPages.STATION]: '/station/', // + stationName
    [AppPages.PANEL]: '/panel/',

    [AppPages.NOT_FOUND]: '/404',
};

export const routeConfig: Record<AppPages, Route> = {
    [AppPages.PANEL]: { path: '/panel/:id', element: <PanelPage /> },
    [AppPages.MAIN]: {
        path: AppRoutes.MAIN,
        element: <MainPage />,
    },
    [AppPages.LOCO]: {
        path: `${AppRoutes.LOCO}:locoId`,
        element: <LocoPage />,
    },
    [AppPages.LOCO_ADMIN]: {
        path: AppRoutes.LOCO_ADMIN,
        element: <LocoAdminPage />,
    },
    [AppPages.CAMERA]: {
        path: AppRoutes.CAMERA,
        element: <Navigate to="/admin?tab=camera" replace />,
    },
    [AppPages.STATION]: {
        path: `${AppRoutes.STATION}:stationName`,
        element: <StationPage />,
    },

    [AppPages.NOT_FOUND]: {
        path: AppRoutes.NOT_FOUND,
        element: <NotFoundPage />,
    },
};
